import { render } from "./SVGNewDoc.vue?vue&type=template&id=6e4934d6"
import script from "./SVGNewDoc.vue?vue&type=script&lang=js"
export * from "./SVGNewDoc.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__